import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth';
import { Router } from '@angular/router';

@Component({
  selector: 'app-authredirect',
  standalone: false,
  template: ` <p>Loading....</p> `,
  styles: ``,
})
export class Authredirect implements OnInit {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.authService.verificarSesion().subscribe((destino) => {
      this.router.navigate([destino === 'login' ? '/login' : `/${destino}`]);
    });
  }
}
